// extracted by mini-css-extract-plugin
module.exports =  {"root":"qGDEuS","divider":"PW8Iwu"};